import React, { useEffect, useState } from 'react';

export default function useExchangeRate() {
  const [rate, setRate] = useState(3.3803); // fallback default
  useEffect(() => {
    fetch(`${import.meta.env.VITE_API_BASE_URL}/api/exchange-rate`)
      .then(res => res.json())
      .then(data => {
        if (data.TND_EXCHANGE_RATE) setRate(data.TND_EXCHANGE_RATE);
      })
      .catch(() => {}); // fallback to default on error
  }, []);
  return rate;
}